/** The money tips a reader can leave: Stripe Checkout on the web, StoreKit consumables on iOS. */
export const TipAmount = {
  Coffee: "coffee",
  Beer: "beer",
  Lunch: "lunch",
} as const;

export type TipAmount = (typeof TipAmount)[keyof typeof TipAmount];

export type TipProduct = {
  key: TipAmount;
  label: string;
  /** Web price in US dollars. */
  priceUsd: number;
  /** App Store Connect product id (consumable). */
  iosProductId: string;
};

export const TIP_PRODUCTS: Record<TipAmount, TipProduct> = {
  [TipAmount.Coffee]: { key: TipAmount.Coffee, label: "Coffee", priceUsd: 5, iosProductId: "com.nottldr.app.tip.coffee" },
  [TipAmount.Beer]: { key: TipAmount.Beer, label: "Beer", priceUsd: 10, iosProductId: "com.nottldr.app.tip.beer" },
  [TipAmount.Lunch]: { key: TipAmount.Lunch, label: "Lunch", priceUsd: 20, iosProductId: "com.nottldr.app.tip.lunch" },
};

export const TIP_AMOUNTS: TipAmount[] = Object.values(TipAmount);

export const IOS_PRODUCT_IDS: Record<TipAmount, string> = {
  [TipAmount.Coffee]: TIP_PRODUCTS.coffee.iosProductId,
  [TipAmount.Beer]: TIP_PRODUCTS.beer.iosProductId,
  [TipAmount.Lunch]: TIP_PRODUCTS.lunch.iosProductId,
};

export const ALL_IOS_PRODUCT_IDS: string[] = Object.values(IOS_PRODUCT_IDS);
